<template>
  <div class="news-details-page">
    <div class="page-header-accent"></div>
    <div class="news-details-container">
      <div class="news-card">
        <div class="news-header">
          <h1 class="news-title">{{ dataInfo.title }}</h1>
          <p class="news-time">{{ dataInfo.updated_at }}</p>
        </div>
        <div class="news-content-wrapper">
          <div class="news-content" v-html="dataInfo.content"></div>
          <div class="news-content" v-html="dataInfo.memo"></div>
        </div>
        <div class="content-divider"></div>
        <div class="action-buttons">
          <div class="apply-button" @click="doactivityapply">
            <span>点我申请</span>
            <i class="fa fa-arrow-right ml-2"></i>
          </div>
          <div class="next-article-button" 
               @click="goToRandomArticle" 
               v-if="relatedItems.length > 0">
            <span>下一篇</span>
            <i class="fa fa-random ml-1"></i>
          </div>
        </div>
      </div>
      <div class="related-news" v-if="showRelated && relatedItems.length > 0">
        <h3 class="related-title">相关活动</h3>
        <div class="related-list">
          <div class="related-item" 
               v-for="(item, index) in relatedItems" 
               :key="item.id || index"
               :class="{ 'active': currentRelatedIndex === index }">
            <span class="related-dot"></span>
            <a href="#" class="related-link" @click.prevent="goToRelatedArticle(index)">{{ item.title }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'activeInfo',
  data() {
    return { 
      dataInfo: {},
      activitylistList: [], // 存储从API获取的所有活动
      relatedItems: [], // 相关活动
      showRelated: true, // 控制是否显示相关活动
      currentRelatedIndex: -1 // 当前选中的相关活动索引
    };
  },
  created() {
    this.activitylist().then(() => {
      const query = this.$route.query;
      if (query.id) {
        this.getInfo(query.id);
      } else if (this.activitylistList.length > 0) {
        const randomId = this.activitylistList[Math.floor(Math.random() * this.activitylistList.length)].id;
        this.getInfo(randomId);
      }
    });
  },
  methods: {
    getInfo(id) {
      this.$parent.showLoading();
      this.$apiFun.post('/api/activitydeatil', { id }).then(res => {
        if (res.code !== 200) {
          this.$parent.showTost(0, res.message);
        } else {
          this.dataInfo = res.data;
          this.generateRelatedItems();
        }
        this.$parent.hideLoading();
      });
    },
    activitylist() {
      const info = { type: '' };
      this.$parent.showLoading();
      return this.$apiFun.post('/api/activitylist', info).then(res => {
        if (res.code !== 200) {
          this.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          this.activitylistList = res.data.data || [];
        }
        this.$parent.hideLoading();
      });
    },    
    generateRelatedItems() {
      if (!this.dataInfo.id || this.activitylistList.length === 0) {
        this.relatedItems = [];
        return;
      }
      const filtered = this.activitylistList.filter(
        item => item.id !== this.dataInfo.id
      );
      this.relatedItems = this.shuffleArray(filtered).slice(0, 2);
      this.checkCurrentInRelated();
    },
    shuffleArray(array) {
      const newArray = [...array];
      for (let i = newArray.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
      }
      return newArray;
    },
    checkCurrentInRelated() {
      if (this.dataInfo.id && this.relatedItems.length) {
        const index = this.relatedItems.findIndex(item => item.id === this.dataInfo.id);
        this.currentRelatedIndex = index !== -1 ? index : -1;
      }
    },
    goToRandomArticle() {
      if (this.relatedItems.length === 0) return;
      const randomIndex = Math.floor(Math.random() * this.relatedItems.length);
      this.goToRelatedArticle(randomIndex);
    },
    goToRelatedArticle(index) {
      const item = this.relatedItems[index];
      if (item && item.id) {
        this.$parent.goNav(`/activeInfo?id=${item.id}`);
        // 更新当前索引
        this.currentRelatedIndex = index;
      }
    },
    doactivityapply() {
      this.$parent.showLoading();
      this.$apiFun.post('/api/doactivityapply', { activityid: this.dataInfo.id }).then(res => {
        this.$parent.showTost(1, res.message);
        this.$parent.hideLoading();
      }).catch(error => {
        this.$parent.hideLoading();
        this.$parent.showTost(0, '申请失败，请稍后重试');
        console.error('申请活动失败:', error);
      });
    },
  }
};
</script>

<style scoped>
.news-details-page {
  background-color: #f5f7fa;
  min-height: 100vh;
  padding: 30px 15px;
  font-family: 'Helvetica', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  position: relative;
}
.page-header-accent {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, #ffcb4c, #ff9a4c);
}
.news-details-container {
  max-width: 800px;
  margin: 0 auto;
  width: 100%;
}
.news-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  padding: 35px;
  margin-bottom: 30px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.news-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
}
.news-header {
  margin-bottom: 30px;
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 20px;
}
.news-title {
  font-size: 28px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 15px;
  line-height: 1.4;
  letter-spacing: -0.02em;
}
.news-time {
  font-size: 14px;
  color: #94a3b8;
  display: flex;
  align-items: center;
}
.news-time::before {
  content: '';
  display: inline-block;
  width: 14px;
  height: 14px;
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2394a3b8'%3E%3Cpath d='M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zm.5-13H11v6l5.2 3.2.8-1.3-4.5-2.7V7z'/%3E%3C/svg%3E") no-repeat center;
  margin-right: 6px;
}
.news-content-wrapper {
  margin-bottom: 20px;
}
.news-content {
  font-size: 16px;
  line-height: 1.8;
  color: #334155;
  margin-bottom: 25px;
}
.news-content img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin: 15px 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.news-content p {
  margin-bottom: 16px;
}
.news-content h2,
.news-content h3 {
  color: #1e293b;
  margin: 24px 0 16px;
  font-weight: 600;
}
.content-divider {
  height: 1px;
  background: #f1f5f9;
  margin: 25px 0;
}
.action-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}
.apply-button {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 180px;
  height: 50px;
  font-size: 16px;
  font-weight: 600;
  color: #482000;
  background: linear-gradient(224deg, #ffdf91, #ffcb4c);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(255, 203, 76, 0.3);
  border: none;
  padding: 0 20px;
}
.apply-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(255, 203, 76, 0.4);
  background: linear-gradient(224deg, #ffe7a8, #ffc436);
}
.apply-button:active {
  transform: translateY(-1px);
}
.next-article-button {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 120px;
  height: 50px;
  font-size: 16px;
  font-weight: 600;
  color: #3b82f6;
  background: #f0f9ff;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #bfdbfe;
  padding: 0 20px;
}
.next-article-button:hover {
  background: #e0f2fe;
  color: #1d4ed8;
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(59, 130, 246, 0.15);
}
.related-news {
  background: #ffffff;
  border-radius: 12px;
  padding: 25px 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}
.related-title {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 18px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f1f5f9;
}
.related-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.related-item {
  display: flex;
  align-items: center;
  transition: transform 0.2s ease;
  padding: 5px 0;
  border-radius: 4px;
}
.related-item:hover {
  transform: translateX(5px);
  background-color: #f8fafc;
}
.related-item.active {
  background-color: #f0f9ff;
  padding-left: 10px;
  padding-right: 10px;
}
.related-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #ffcb4c;
  margin-right: 10px;
}
.related-link {
  font-size: 15px;
  color: #3b82f6;
  text-decoration: none;
  transition: color 0.2s ease;
  flex: 1;
  padding: 3px 0;
}
.related-link:hover {
  color: #1d4ed8;
  text-decoration: underline;
}
@media (max-width: 768px) {
  .news-card {
    padding: 25px 20px;
  }
  .news-title {
    font-size: 24px;
  }
  .action-buttons {
    flex-direction: column;
    gap: 10px;
  }
  .apply-button, .next-article-button {
    width: 100%;
    max-width: none;
  }
}
@media (max-width: 480px) {
  .news-details-page {
    padding: 20px 10px;
  }
  .news-card {
    padding: 20px 15px;
    border-radius: 8px;
  }
  .news-title {
    font-size: 20px;
  }
  .news-content {
    font-size: 15px;
    line-height: 1.7;
  }
  .apply-button, .next-article-button {
    height: 46px;
    font-size: 15px;
  }
  .related-news {
    padding: 20px 15px;
  }
  .related-title {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/activeInfo.vue